import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';


import * as c from '../../../constants';

import ItemDropdownField from '../../common/ItemDropdownField';
import ClassDropdownField from '../../common/ClassDropdownField';


class GroupListDropdown extends Component {
  renderDropdown() {
    const { form, name, label, groupType } = this.props;
    const dropdownProps = { form, name, label };

    if (groupType === c.FORM_GROUP_TYPE_ITEM) {
      return (
        <ItemDropdownField
          {...dropdownProps}
        />
      )
    }

    if (groupType === c.FORM_GROUP_TYPE_CLASS) {
      return (
        <ClassDropdownField 
          {...dropdownProps}
        />
      );
    }

    return null;
  }


  render() {
    return this.renderDropdown();
  }
}


function mapStateToProps(state, { form }) {
  const getFields = formValueSelector(form);
  return {
    groupType: getFields(state, 'group_type') 
  };
}


export default connect(mapStateToProps)(GroupListDropdown);
